import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';

export default function HomeFeedTabs() {
  return <nav className='home-feed-tabs'>
    <NavLink to='/home' exact activeClassName='is-active'><FormattedMessage id='column.home' defaultMessage='Home' /></NavLink>
    <NavLink to='/public/local' isActive={(match, location) => location.pathname.startsWith('/public')} activeClassName='is-active'><FormattedMessage id='community.feed_tab' defaultMessage='Public' /></NavLink>
  </nav>;
}
